import Vue from 'vue';

export const TEMED_WIDGET_EVENTS = {
  TEST_EVENT: 'TEST_EVENT',
  GEO_LOCATION_CHANGED: 'GEO_LOCATION_CHANGED',

}

export const SEARCH_WIDGET_EVENTS = {
  SEARCH_TOGGLE_FORM: 'SEARCH_TOGGLE_FORM'
}

export const EventBus = new Vue();
